// The product paths of decision 3, each with its branded login door, and where each sends people
// until its product moves in (CLAUDE.md, "Products that haven't moved in yet"). This is app config,
// not rows: logged out, the database gives nothing, so a logged-out screen can't read it from there
// (docs/data-model.md, section 2). A door added in admin needs a change here in phase 1 (question 26).
//
// Which products haven't moved in is decided in 2 places:
// - logged in, a product row the member can see says so itself (catalogue.moved_in);
// - otherwise (logged out, or a row they can't see) the build's HUB_NOT_MOVED_IN list says so.
//   Staging leaves the list empty, so every door and page renders and the boards can be checked.
//
// The paths themselves and the helpers that read no build setting are in config/productPaths.js
// (since 10 Oct, so a test can import them), re-exported here.
import { ENV } from '../lib/env.js'
import { productPathConfig } from './productPaths.js'

export { PRODUCT_PATHS, basePath, productPathConfig, siteFor, productTypeByName } from './productPaths.js'

// The build says this path's product hasn't moved in: where to send people instead, or null.
export function configRedirect(path) {
  const p = productPathConfig(path)
  if (!p || !ENV.notMovedIn.includes(p.path)) return null
  return p.notMovedIn
}

// A product row the member can see says it hasn't moved in: where to send them, or null.
export function rowRedirect(path, row) {
  if (!row || row.moved_in) return null
  const p = productPathConfig(path)
  return p ? p.notMovedIn : '/'
}
